<h2 mat-dialog-title class="dialog-title !text-xl !font-bold !mb-2">Alterar forma de pagamento em massa</h2>

<mat-dialog-content class="dialog-content">

    <div class="alert alert-info mb-3" role="alert">
        A forma de pagamento será <strong>substituída</strong> nos documentos de
        <strong>{{ qtdSelecionados }} parcela(s)</strong> selecionada(s).
    </div>

    <mat-form-field appearance="outline" class="w-100">
        <mat-label>Nova forma de pagamento</mat-label>
        <mat-select [(ngModel)]="idFormaPagamento">
            @for (forma of data.formasPagamento; track forma.idFormaPagamento) {
            <mat-option [value]="forma.idFormaPagamento">{{ forma.descricao }}</mat-option>
            }
        </mat-select>
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions mt-4">
    <button mat-flat-button class="btn-secondary mr-2" (click)="close()">Cancelar</button>
    <button mat-flat-button class="btn-primary" [disabled]="!idFormaPagamento" (click)="confirm()">
        Salvar alterações
    </button>
</mat-dialog-actions>
